import { Security } from './security'

function plugin(Vue, opts) {
  if (!opts.router) {
    throw new Error('You must supply a router instance in the options.')
  }

  const security = new Security(opts.router)

  Vue.$user = security
  Vue.prototype.$user = security

  opts.router.beforeEach((...args) => {
    security.resolve(...args)
  })
}

export default plugin
